import axios from "axios";
import store from './store';
import { spaceHeader } from './utils/space';
import router from './router';
import { sessionIdle } from './utils/activity';

const apiDataClient = axios.create({
    baseURL: process.env.VUE_APP_DATA_API_BASE_URL,
    withCredentials: true
});

// the space of the switcher (personal or a team, task 59) goes with every request
apiDataClient.interceptors.request.use(config => {
  const value = spaceHeader(store)['X-Sl-Space'];
  if (config.headers && typeof config.headers.set === 'function') config.headers.set('X-Sl-Space', value);
  else config.headers = { ...(config.headers || {}), 'X-Sl-Space': value };
  return config;
});

// Flag to prevent multiple concurrent refresh attempts
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  
  failedQueue = [];
};

apiDataClient.interceptors.response.use(
  response => response,
  async error => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 403) {
      // @todo подумать как обрабатывать 403 из админки ajax
      console.error('Access Denied - 403 Forbidden');
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 400 && error.response.data.detail) {
      console.log('Test 400');
      // Note: Cannot use this.$emit here as this is not a component context
      return Promise.reject(error);
    }

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      // minutes without an action: no refresh, the session ends (as in apiClient)
      if (sessionIdle()) {
        await store.dispatch('logoutIdle');
        if (router.currentRoute.value.path !== '/signin') router.push('/signin');
        return Promise.reject(error);
      }
      if (isRefreshing) {
        // If already refreshing, queue this request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => {
          return apiDataClient(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        // Set refreshing state
        store.dispatch('handleTokenRefresh', true);
        
        // Use main API client for refresh since data client might not have auth endpoints
        const mainApiClient = (await import('./apiClient')).default;
        await mainApiClient.post('/auth/refresh');
        
        processQueue(null);
        isRefreshing = false;
        store.dispatch('handleTokenRefresh', false);
        
        // Retry original request
        return apiDataClient(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError, null);
        isRefreshing = false;
        store.dispatch('handleTokenRefresh', false);
        
        // Refresh failed, logout user
        console.error('Token refresh failed - logging out');
        await store.dispatch('logout');
        store.commit('setTimeOut', true);
        
        // Redirect to login if not already there
        if (router.currentRoute.value.path !== '/signin') {
          router.push('/signin');
        }
        
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default apiDataClient;
